export default __webpack_public_path__ + "static/media/nounders_dev.4bf25e9f.png";